import { ProductInfoPrice } from '@/app/[locale]/product/[slug]/_components/product-info/product-info-price'
import { ProductInfoSharing } from '@/app/[locale]/product/[slug]/_components/product-info/product-info-sharing'
import { ProductInfoSizes } from '../product-info-sizes'
import { ProductInfoSizesCombo } from '../product-info-sizes/product-size-combo'
import { ProductSuggestCarousel } from '../product-info-suggest'
import { ProductPromotion } from '../product-promotion'
import { ProductPromotionGift } from '../product-promotion-gift'
import { ProductInfoAddCart } from './product-info-add-cart'
import { ProductInfoCoolcashReward } from './product-info-coolcash-reward'
import { ProductInfoCoolclubPricing } from './product-info-coolclub-pricing'
import { ProductInfoFlashSale } from './product-info-flash-sale'
import { ProductInfoFreeship } from './product-info-freeship'
import { ProductInfoPolicy } from './product-info-policy'
import { ProductInfoPricingPolicy } from './product-info-pricing-policy'
import { ProductInfoRating } from './product-info-rating'
import { ProductInfoRatingSummary } from './product-info-rating-summary'
import { ProductInfoVariants } from './product-info-variants'
import { ProductInfoVouchers } from './product-info-vouchers'

export const ProductInfo = {
  AddCart: ProductInfoAddCart,
  Policy: ProductInfoPolicy,
  PricingPolicy: ProductInfoPricingPolicy,
  Rating: ProductInfoRating,
  RatingSummary: ProductInfoRatingSummary,
  Sizes: ProductInfoSizes,
  SizesCombo: ProductInfoSizesCombo,
  Suggest: ProductSuggestCarousel,
  Variants: ProductInfoVariants,
  Vouchers: ProductInfoVouchers,
  Freeship: ProductInfoFreeship,
  CoolcashReward: ProductInfoCoolcashReward,
  Price: ProductInfoPrice,
  Sharing: ProductInfoSharing,
  FlashSale: ProductInfoFlashSale,
  Promotion: ProductPromotion,
  PromotionGift: ProductPromotionGift,
  CoolclubPricing: ProductInfoCoolclubPricing,
}
